import { useSite } from "./use-site";
export var useSiteCreator = function useSiteCreator() {
  var site = useSite();

  if (site && site.creator) {
    return site.creator;
  }

  return null;
};